import { Button, Modal, Stack, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";

export default function ErrorModal({
	opened,
	errorMessage,
	errorMessageDescription,
}) {
	const navigate = useNavigate();

	return (
		<Modal
			opened={opened}
			onClose={() => {}}
			centered
			withCloseButton={false}
			overlayBlur={4}
			overlayOpacity={0.6}
			radius="md"
			padding="10vw"
			py="6vw"
		>
			<Stack gap="6vw" align="center">
				<Text align="center" weight="bold" size="5.58vw">
					{errorMessage}
				</Text>
				<Text align="center" size="3.7vw" color="#757575" lh="1.4">
					{errorMessageDescription}
				</Text>
				<Button
					w="100%"
					radius="xl"
					size="md"
					color="black"
					style={{ border: "2px solid #DDDDDD" }}
					onClick={() => navigate("/")}
				>
					返回首頁
				</Button>
			</Stack>
		</Modal>
	);
}
